import { API } from "./utils"

export const payouts = {
  payoutsList: (params = null) => API.get("/distributions/payouts/", { params }),
  createPayout: (data) => API.post("/distributions/payouts/", data),
  getPayout: (id) => API.get(`/distributions/payouts/${id}/`),
  updatePayout: (id, data, params = null) => API.patch(`distributions/payouts/${id}/`, data, { params }),
  getTransactionsRemovalList: (params = null) => API.get("/distributions/transaction-removal-requests/", { params }),
  createTransactionRemovalRequest: (data = null) => API.post("/distributions/transaction-removal-requests/", data),
  approveTransactionRemovalRequest: (uuid) => API.post(`/distributions/transaction-removal-requests/${uuid}/approve/`),
  declineTransactionRemovalRequest: (uuid, data = null) => API.post(`/distributions/transaction-removal-requests/${uuid}/decline/`, data),
  getTransactionsRefreshList: (params = null) => API.get("/distributions/transaction-refresh-requests/", { params }),
  createTransactionRefreshRequest: (data = null) => API.post("/distributions/transaction-refresh-requests/", data),
  executePayoutJob: (data = null) => API.post("/distributions/payout-job-execution/", data),
  applyPayout: (id) => API.post(`/distributions/payouts/${id}/apply/`),
  generateReports: (id) => API.post(`/distributions/payouts/${id}/generate_reports/`),
  deletePayout: (id) => API.delete(`/distributions/payouts/${id}/`),
}
